import { useAppContext } from '../../context/AppContext.js';
import "./style.css";
import api from "../../services/api";
import React, { useState, useEffect } from 'react';
import FloatingMenu from "../../componente/menuflutuante/index.jsx"; // Componente do menu flutuante
import TopBar from "../../componente/topbar/index.jsx";

function Mochila() {
    //campos mochila    
    const [CodInventario, setCodInventario] = useState(0);
    const [SaldoCoin, setSaldoCoin] = useState(0);
    const [SaldoReal, setSaldoReal] = useState(0);
    const [listabeneficio, setlistabeneficio] = useState([]);
    const [listaitens, setlistaitens] = useState([]);

    const { codcolaborador, accessKey, nomeDoColaborador, fotoPerfil  } = useAppContext(); // Acessa os dados do contexto

    function ListarMochila() {
        api
            .get("/v1/cadastro/colaborador/mochilacolaborador", {
                params: {
                    busca: "",
                    codcolaborador,
                },
                headers: {
                    Authorization: `Bearer ${accessKey}`,
                },
            })
            .then(function (response) {
                setCodInventario(response.data.codinventario);
                setSaldoCoin(response.data.saldocoin);
                setSaldoReal(response.data.saldoreal);
            })
            .catch(function (err) {
                console.log("ops! ocorreu um erro: " + err);
            });

        api
            .get("/v1/cadastro/colaborador/colaboradortitulo", {
                params: {
                    busca: "",
                    codcolaborador,
                },
                headers: {
                    Authorization: `Bearer ${accessKey}`,
                },
            })
            .then(function (response) {
                setlistabeneficio(response.data);
            })
            .catch(function (err) {
                console.log("ops! ocorreu um erro: " + err);
            });        
    }

    function ListaItensMochila(){
        api
            .get("/v1/cadastro/colaborador/mochilacolaborador/itensmochila", {
                params: {
                    busca: "",
                    codinventario: CodInventario,
                },
                headers: {
                    Authorization: `Bearer ${accessKey}`,
                },
            })
            .then(function (response) {
                setlistaitens(response.data);
            })
            .catch(function (err) {
                console.log("ops! ocorreu um erro: " + err);
            });
    }

    useEffect(() => {
        ListarMochila();
    }, []);

    useEffect(() => {
        ListaItensMochila();
    }, [CodInventario]);

    return (
        <div >
            <TopBar nomeColaborador={nomeDoColaborador} foto={fotoPerfil} />
            <FloatingMenu />
            <div className="modal-header">
                <h5 className="modal-title">Mochila de Itens</h5>                
            </div>
            <div className="modal-body">
                {/* Totalizadores */}
                <div className="d-flex justify-content-between p-2 bg-dark text-white rounded mb-3">
                    <div className="d-flex align-items-center">
                        <i className="fas fa-coins me-2"></i> <span>Total Coins: </span> {SaldoCoin}
                    </div>
                    <div className="d-flex align-items-center">
                        <i className="fas fa-dollar-sign me-2"></i> <span>Total Real: </span> R$ {SaldoReal}
                    </div>
                </div>

                {/* Tabela de Cards */}
                <div className="d-grid gap-2 product-grid">
                    {listaitens.map((product, index) => (
                        <div className="card text-center bg-secondary text-white product-card" key={index}>
                            <img src={product.foto} className="card-img-top" alt={product.description} />
                            <div className="card-body">
                                <h6 className="card-title">{product.descricao}</h6>
                                <p className="card-text">Qtd: {product.qtde}</p>
                            </div>
                        </div>
                    ))}
                </div>

                {/* Lista de Benefícios */}
                <div className="mt-4 p-3 bg-dark text-white rounded">
                    <h6><i className="fas fa-gift me-2"></i> Benefícios</h6>
                    <ul className="mb-0">
                        {listabeneficio.map((benefit, index) => (
                            <li key={index}>{benefit.descricao}</li>
                        ))}
                    </ul>
                </div>
            </div>            
        </div>
    );
}

export default Mochila;